"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CartwireApi {
    binInit(url) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!document.querySelector(`script[id="cartwire-script"]`)) {
                const script = document.createElement('script');
                script.src = url;
                script.id = 'cartwire-script';
                document.body.appendChild(script);
            }
        });
    }
    binClick(obj, widgetTheme, locale) {
        window['loadsWidget'](obj['dataset']['value'], obj, widgetTheme, locale);
        console.log(`[bin.cartwire.api]:widget triggred`);
    }
}
exports.default = CartwireApi;
